import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import "./Home.css";
import img01 from "../../img/01.jpg";
import img02 from "../../img/02.jpg";
import img03 from "../../img/03.jpg";
import img04 from "../../img/04.jpg";
import img05 from "../../img/05.jpg";
import img06 from "../../img/06.jpg";
import img07 from "../../img/07.jpg";
import HomeCard from "../HomeCard/HomeCard";

const Home = () => {
  const [homeCourses, setHomeCourses] = useState([]);
  useEffect(() => {
    fetch("/home-data.json")
      .then((res) => res.json())
      .then((data) => setHomeCourses(data));
  }, []);
  return (
    <div className="">
      <div className="home-text text-white">
        <h1>Admission Open Now</h1>
        <h4>Call Now +971-58-5580505</h4>
      </div>
      <div>
        <Carousel fade>
          <Carousel.Item>
            <img className="d-block w-100" src={img01} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={img02} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={img03} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={img04} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={img05} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={img06} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={img07} alt="First slide" />
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="container mb-5 mt-5">
        <div className="row row-cols-1 row-cols-md-3 g-4">
          {homeCourses.map((homeCourse) => (
            <HomeCard key={homeCourse.Age} homeCourse={homeCourse}></HomeCard>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
